import { Globe, Linkedin, Youtube, Instagram, AtSign } from "lucide-react";

const LABELS = {
  x: "X", bluesky: "Bluesky", linkedin: "LinkedIn", substack: "Substack", youtube: "YouTube",
  instagram: "Instagram", threads: "Threads", tiktok: "TikTok", website: "Website",
};
const ICONS = { linkedin: Linkedin, youtube: Youtube, instagram: Instagram, website: Globe };

export const SocialChips = ({ socials = [], className = "", size = "xs" }) => {
  if (!socials.length) return null;
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="social-chips">
      {socials.map((s) => {
        const Icon = ICONS[s.platform] || AtSign;
        return (
          <a
            key={s.url}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`social-${s.platform}`}
            title={`${LABELS[s.platform] || s.platform}${s.handle ? ` · ${s.handle}` : ""}`}
            className={`inline-flex items-center gap-1.5 border border-slate-300 hover:border-[var(--accent)] hover:text-[var(--accent)] text-slate-600 px-2 py-1 text-${size} transition-colors`}
          >
            <Icon className="w-3 h-3" />
            {s.handle || LABELS[s.platform] || s.platform}
          </a>
        );
      })}
    </div>
  );
};

export default SocialChips;
